import PropTypes from "prop-types";
import React from "react";

// Custom components
import IntegerInputMapping from "@/Layouts/components/InputComponents/IntegerInputMapping";
import LineInputsLoader from "@/Layouts/components/Skeletons/LineInputsLoader";

// MUI
import { Grid } from "@mui/material";

export default function TopPerformer(props) {
	const {
		sectionId = "topSalesBonus",
		content = [],
		loading = false,
		readOnly = false,
		onActionUpdate = () => {},
		useSectionsErrors = () => {},
	} = props;

	// Used to add errors to the pay plan context
	const { addSectionError, removeSectionError, clearSectionErrors } = useSectionsErrors?.() || {};

	const handleUpdate = (data) => {
		onActionUpdate?.(sectionId, null, data);
	};

	const handleValidation = (section, value) => {
		value ? removeSectionError?.(section, null, value) : addSectionError?.(section, null, value);
	};

	React.useEffect(() => {
		return () => {
			clearSectionErrors?.(sectionId);
		};
	}, [sectionId, clearSectionErrors]);

	return (
		<Grid container mt={2} mb={"-10px"} px={"32px"}>
			<Grid item xs={12}>
				{loading ? (
					<LineInputsLoader title inputsAmount={3} justifyContent={"flex-start"} mt={0} />
				) : (
					<IntegerInputMapping
						bonuses={content || []}
						readOnly={readOnly}
						onActionUpdate={handleUpdate}
						onActionValidation={(value) => handleValidation(sectionId, value)}
					/>
				)}
			</Grid>
		</Grid>
	);
}
TopPerformer.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.array,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};
